// extracted by mini-css-extract-plugin
export var sophisticatedElegance = "styles-module--sophisticatedElegance--X0juF";
export var headerContainer = "styles-module--headerContainer--NCG3Z";
export var sophisticatedEleganceGallery = "styles-module--sophisticatedEleganceGallery--oNcv4";
export var sophisticatedEleganceRow = "styles-module--sophisticatedEleganceRow--FWfpy";